/**
 * TimeOffActions Component
 * Handles Approve/Reject/Cancel/Delete actions with confirmation modals
 */

import React from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import moment from "moment";
import { ThreeDots } from "react-loader-spinner";
import tikgImage from "../../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import cancelImage from "../../../images/singleinvoice/cancel.svg";
import editImage from "../../../images/icons/edit-pen.svg";
import Delete from "../../../images/icons/delete.svg";

const TimeOffActions = ({
  user = null,
  torStatus = "",
  startDate = "",
  isSubmitLoading = false,
  onEdit = null,
  onApprove = null,
  onReject = null,
  onCancel = null,
  onDelete = null,
  approveModalOpen = false,
  rejectModalOpen = false,
  cancelModalOpen = false,
  deleteModalOpen = false,
  onCancelApprove = null,
  onCancelReject = null,
  onCancelCancel = null,
  onCancelDelete = null,
  onConfirmApprove = null,
  onConfirmReject = null,
  onConfirmCancel = null,
  onConfirmDelete = null,
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3,
  TEAM_MANAGER = 7,
}) => {
  const modalStyle = {
    content: {
      height: "41%",
      width: "30%",
      position: "fixed",
      top: "50%",
      left: "50%",
      parent: document.querySelector(".admin-outer.time.tracker"),
    },
  };

  const deleteModalStyle = {
    content: {
      height: "41%",
      width: "30%",
      position: "fixed",
      top: "50%",
      left: "50%",
      parent: document.querySelector(".admin-outer.time.tracker"),
    },
  };

  return (
    <div className={`form-field-client-btns timeoff-btn`}>
      {/* Admin/Manager Actions: Approve/Reject */}
      {(user && (user.userType === SUPER_ADMIN || user.userType === ADMIN || user.userType === TEAM_MANAGER)) && (torStatus !== "Cancelled") && (
        <>
          {torStatus === "Approved" ? (
            <Link className="Approve-singlebtn approved disable-cursor">
              {" "}
              Approved <img src={tikgImage} alt="Edit Icon" />{" "}
            </Link>
          ) : (
            <Link className="Approve-singlebtn" onClick={onApprove} disabled={isSubmitLoading}>
              Approve <img src={tikgImage} alt="Edit Icon" />{" "}
            </Link>
          )}
          <Modal
            className="delete-modal"
            isOpen={approveModalOpen}
            onRequestClose={!isSubmitLoading ? onCancelApprove : undefined}
            contentLabel="Confirm Approve"
            style={modalStyle}
          >
            <div className="delete-modal-content">
              <h2>Confirm Approve</h2>
              <p>Are you sure you want to Approve this Time Off Request?</p>
              {isSubmitLoading ? (
                <div className="outter-load-table">
                  <ThreeDots
                    height="28"
                    width="30"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <div className="delete-modal-buttons">
                  <button className="buttons-approved" onClick={onConfirmApprove} disabled={isSubmitLoading}>
                    Approve
                  </button>
                  <button onClick={onCancelApprove} disabled={isSubmitLoading}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </Modal>

          {torStatus === "Rejected" ? (
            <a className="Reject-singlebtn rejected disable-cursor">
              {" "}
              Rejected <img src={crssrImage} alt="Edit Icon" />{" "}
            </a>
          ) : (
            <a className="Reject-singlebtn" onClick={onReject} disabled={isSubmitLoading}>
              Reject <img src={crssrImage} alt="Edit Icon" />{" "}
            </a>
          )}
          <Modal
            className="delete-modal"
            isOpen={rejectModalOpen}
            onRequestClose={!isSubmitLoading ? onCancelReject : undefined}
            contentLabel="Confirm Reject"
            style={modalStyle}
          >
            <div className="delete-modal-content">
              <h2>Confirm Reject</h2>
              <p>Are you sure you want to Reject this Time Off Request?</p>
              {isSubmitLoading ? (
                <div className="outter-load-table">
                  <ThreeDots
                    height="28"
                    width="30"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <div className="delete-modal-buttons">
                  <button className="buttons-rejected" onClick={onConfirmReject} disabled={isSubmitLoading}>
                    Reject
                  </button>
                  <button onClick={onCancelReject}>Cancel</button>
                </div>
              )}
            </div>
          </Modal>
        </>
      )}

      {/* Edit Button */}
      {user &&
        ((user.userType === USER && torStatus === "Pending") ||
          ([SUPER_ADMIN, ADMIN, TEAM_MANAGER].includes(user.userType) &&
            ["Pending", "Approved", "Rejected"].includes(torStatus))) && (
          <div className="form-field-client-btns delete-timeoff delete-timeoff-edit">
            <button
              type="button"
              className="delete-client edit-time-0ff-button"
              onClick={onEdit}
            >
              <img alt="Edit" src={editImage} /> Edit
            </button>
          </div>
        )}

      {/* Cancel/Delete Actions */}
      {((user && (user.userType === SUPER_ADMIN || user.userType === ADMIN || user.userType === TEAM_MANAGER)) ||
        (startDate && moment(startDate, 'DD/MM/YYYY').toDate() > new Date())) && (
        <>
          {torStatus === "Cancelled" ? (
            <a className="cancel-singlebt Cancelled disable-cursor">
              {" "}
              Cancelled <img src={cancelImage} alt="Edit Icon" />{" "}
            </a>
          ) : (
            <a className="cancel-singlebtn" onClick={onCancel} disabled={isSubmitLoading}>
              Cancel <img src={crssrImage} alt="Edit Icon" />{" "}
            </a>
          )}
          <Modal
            className="delete-modal"
            isOpen={cancelModalOpen}
            onRequestClose={!isSubmitLoading ? onCancelCancel : undefined}
            contentLabel="Confirm Cancel"
            style={modalStyle}
          >
            <div className="delete-modal-content">
              <h2>Confirm Cancel</h2>
              <p>Are you sure you want to Cancel this Time Off Request?</p>
              {isSubmitLoading ? (
                <div className="outter-load-table">
                  <ThreeDots
                    height="28"
                    width="30"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <div className="delete-modal-buttons">
                  <button className="modal-btn modal-btn-calendar cancel-border" onClick={onConfirmCancel} disabled={isSubmitLoading}>
                    Cancel
                  </button>
                  <button onClick={onCancelCancel}>Close</button>
                </div>
              )}
            </div>
          </Modal>

          <div className="form-field-client-btns delete-timeoff">
            <button
              type="button"
              className="delete-client"
              onClick={onDelete}
            >
              <img src={Delete} alt="Delete" /> Delete Request
            </button>
            <Modal
              className="delete-modal"
              isOpen={deleteModalOpen}
              onRequestClose={!isSubmitLoading ? onCancelDelete : undefined}
              contentLabel="Confirm Delete"
              style={deleteModalStyle}
            >
              <div className="delete-modal-content">
                <h2>Confirm Delete</h2>
                <p>Are you sure you want to delete this Time Off Request?</p>
                {isSubmitLoading ? (
                  <div className="outter-load-table">
                    <ThreeDots
                      height="28"
                      width="30"
                      radius="9"
                      color="#6479f9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  </div>
                ) : (
                  <div className="delete-modal-buttons">
                    <button className="buttons-rejected" onClick={onConfirmDelete} disabled={isSubmitLoading}>
                      Delete
                    </button>
                    <button onClick={onCancelDelete} disabled={isSubmitLoading}>
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </Modal>
          </div>
        </>
      )}
    </div>
  );
};

export default TimeOffActions;
